export default {
  metadata: {
    version: '1.0.0',
    id: 'notification-banner-1.0.0',
    name: 'JDSNotificationBanner'
  },
  hierarchy: {
    'root-container': [
      {
        'main-container': [
          {
            'jds-icon-container': ['jds-icon']
          },
          {
            'text-container': ['heading-jds-text', 'support-jds-text']
          },
          {
            'button-container': ['cta-jds_button', 'close-jds_button']
          }
        ]
      },
      {
        'bottom-container': ['bottom-cta-jds_button']
      }
    ]
  },
  base: {
    'root-container': {
      hidden: false,
      'min-height': '{n_0}',
      width: '{n_1}',
      'flex-direction': '{n_2}',
      'justify-content': '{n_3}',
      'align-items': '{n_4}',
      'padding-top': '{n_5}',
      'padding-right': '{n_6}',
      'padding-bottom': '{n_7}',
      'padding-left': '{n_8}',
      gap: '{n_9}',
      'border-radius': '{n_10}',
      'background-color': '{n_11}',
      'enter-animation-name': 'slideVerticallyDown',
      'exit-animation-name': 'slideVerticallyUp',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'translate-y': 0,
      transition: {
        property: ['translate-y'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulEntrance}'
      }
    },
    'main-container': {
      'flex-direction': '{n_12}',
      'justify-content': '{n_13}',
      'align-items': '{n_14}',
      width: '{n_15}',
      gap: '{n_16}'
    },
    'text-container': {
      flex: 1,
      'justify-content': '{n_17}',
      'align-items': '{n_18}',
      'flex-direction': '{n_19}',
      gap: '{n_20}'
    },
    'button-container': {
      'flex-direction': '{n_21}',
      gap: '{n_22}'
    },
    'cta-jds_button': {
      hidden: false,
      size: 'small',
      kind: 'secondary'
    },
    'close-jds_button': {
      size: 'small',
      kind: 'tertiary',
      icon: 'ic_close'
    },
    'bottom-container': {
      hidden: true,
      'flex-direction': '{n_24}',
      'justify-content': '{n_25}',
      'align-items': '{n_26}',
      width: '{n_23}'
    },
    'bottom-cta-jds_button': {
      size: 'small',
      kind: 'secondary'
    },
    'jds-icon': {
      size: '{icon_24}',
      color: '{icon_7}'
    },
    'jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_23}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    'heading-jds-text': {
      'font-family': '{text_137}',
      color: '{text_20}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1
    },
    'support-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 4,
      maxLines: 4
    }
  },
  variant: {
    ctaPosition: {
      bottom: {
        'cta-jds_button': {
          hidden: true
        },
        'bottom-container': {
          hidden: false
        }
      }
    },
    open: {
      false: {
        'root-container': {
          hidden: true,
          'translate-y': '{size.negativeMax}',
          transition: {
            'timing-function': '{easeJoyfulExit}'
          }
        }
      }
    },
    _showClose: {
      false: {
        'close-jds_button': {
          hidden: true
        }
      }
    },
    _hasDescription: {
      false: {
        'main-container': {
          'align-items': '{n_27}'
        },
        'support-jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      true: {
        desktop: {
          'root-container': {
            'padding-left': '{n_28}',
            'padding-right': '{n_29}',
            'border-radius': 0
          }
        },
        mobile: {
          'root-container': {
            'padding-left': '{n_30}',
            'padding-right': '{n_31}',
            'border-radius': 0
          }
        },
        tablet: {
          'root-container': {
            'padding-left': '{n_32}',
            'padding-right': '{n_33}',
            'border-radius': 0
          }
        }
      }
    }
  ],
  combination_config: [['global', '_platform']],
  api: {
    config: {
      global: {
        values: [false, true]
      },
      open: {
        values: [true, false]
      },
      closeOnSuffixClick: {
        values: [true, false]
      },
      ctaPosition: {
        values: ['inline', 'bottom']
      },
      _showClose: {
        values: [true, false]
      },
      _platform: {
        values: ['desktop', 'tablet', 'mobile']
      },
      _hasDescription: {
        values: [true, false]
      }
    },
    data: {
      'cta-jds_button': {
        label: {
          type: 'string',
          name: 'cta'
        }
      },
      'close-jds_button': {
        icon: {
          type: 'icon',
          name: 'suffix'
        }
      },
      'bottom-cta-jds_button': {
        label: {
          type: 'string',
          name: 'cta'
        }
      },
      'jds-icon': {
        value: {
          type: 'icon',
          name: 'prefix'
        }
      },
      'heading-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      },
      'support-jds-text': {
        value: {
          type: 'string',
          name: 'description'
        }
      }
    },
    events: {
      'cta-jds_button': {
        onClick: 'onCTAClick'
      },
      'bottom-cta-jds_button': {
        onClick: 'onCTAClick'
      },
      'close-jds_button': {
        onClick: 'onSuffixClick'
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'banner'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'title'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'cta-jds_button': {
        properties: {
          ariaLabel: 'ctaAriaLabel',
          ariaDescribedby: {
            name: 'ctaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'close-jds_button': {
        properties: {
          ariaLabel: {
            name: 'closeButtonAriaLabel',
            value: 'Close Button'
          },
          ariaDescribedby: {
            name: 'closeButtonAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'bottom-cta-jds_button': {
        properties: {
          ariaLabel: 'ctaAriaLabel',
          ariaDescribedby: {
            name: 'ctaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
